import "./integrations.css";
import integrationsMap from "../../../assets/job-seeker-integrations.webp";

const Integrations = () => (
  <section className="s-section s-integrations">
    <div className="home-container s-integrations-grid">
      <div className="s-integrations-copy">
        <h2 className="s-integrations-title">
          Connect RAIN with the tools you already use
        </h2>
        <p className="s-lead s-integrations-sub">
          Your inbox, your calendar, your school&rsquo;s job board, and the
          sites you apply on. RAIN plugs into them, so applications, outreach,
          and interviews all stay in one place without you copying anything
          across.
        </p>
      </div>

      <div className="s-integrations-visual">
        <img width={1248} height={781} decoding="async"
          src={integrationsMap}
          alt="RAIN at the centre of the tools students already use for the job search"
          loading="lazy"
        />
      </div>
    </div>
  </section>
);

export default Integrations;
